
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  methods: {
    tileLayout(tileType) {
      return !!tileType.includes('large')
    },
  },
}
